import { useLayoutEffect, useSyncExternalStore } from 'react';
import { twMerge } from 'tailwind-merge';
import Payments from '~/stores/payments';

export default function PaymentCardInput({
  className,
}: {
  className?: string;
}) {
  const paymentUI = useSyncExternalStore(
    (listener) => Payments.subscribe(listener),
    () => Payments.getSnapshot(),
  );

  useLayoutEffect(() => paymentUI?.mount('#card-element'), [paymentUI]);

  return <div id="card-element" className={twMerge('w-full', className)} />;
}
